var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgK8SService = function SvgK8SService(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "currentColor"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.438 10.562a3 3 0 1 0 0-5.124l.739.739a2 2 0 1 1 0 3.646z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M3 2h10a1 1 0 0 1 1 1v10a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1v-2h1v2h10V3H3v2H2V3a1 1 0 0 1 1-1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M1 8.5h4.586L4.293 9.793 5 10.5 7.5 8 5 5.5l-.707.707L5.586 7.5H1z"
  })));
};
export default SvgK8SService;